import { render, staticRenderFns } from "./PlaniranePosete.vue?vue&type=template&id=5b84da7e&"
import script from "./PlaniranePosete.vue?vue&type=script&lang=ts&"
export * from "./PlaniranePosete.vue?vue&type=script&lang=ts&"
import style0 from "./PlaniranePosete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports